import { statusFor } from "../../features/leases/pages/components/LeasePortfolioFilters.jsx";

// Presentation only: never rewrite the canonical action bucket or source dates.
export function timelineLaneFor(lease, now = new Date()) {
  return statusFor(lease, now) === "pre_commencement"
    ? "incoming"
    : lease.action_window_bucket ?? "monitor";
}

export function incomingStartDate(lease) {
  const value = lease.startDate;
  if (typeof value === "string") {
    const source = value.trim();
    if (!/^\d{4}-\d{2}-\d{2}(?:T.*)?$/.test(source)) return null;
    if (source.includes("T") && !Number.isFinite(new Date(source).getTime())) return null;
  }
  const key = value instanceof Date
    ? (Number.isFinite(value.getTime()) ? value.toISOString().slice(0, 10) : "")
    : String(value ?? "").trim().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(key)) return null;
  const date = new Date(`${key}T00:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === key ? date : null;
}

export function compareIncomingStarts(a, b) {
  const da = incomingStartDate(a);
  const db = incomingStartDate(b);
  if (!da && !db) return 0;
  if (!da) return 1;
  if (!db) return -1;
  return da - db; // Stable sort retains input order for ties, including unknowns.
}
